import { render, staticRenderFns } from "./ProceedToSurvey.vue?vue&type=template&id=2a4fd54c"
import script from "./ProceedToSurvey.vue?vue&type=script&lang=js"
export * from "./ProceedToSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports